/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CategoryCountResponseModelList {
    getFixupPrototypeFunction() { return CategoryCountResponseModelList.fixupPrototype; }

    static newInstance(model: Partial<CategoryCountResponseModelList>): CategoryCountResponseModelList {
        let obj = Object.assign(new CategoryCountResponseModelList(), model);
        CategoryCountResponseModelList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CategoryCountResponseModelList>): CategoryCountResponseModelList {
        if (!model) return null;
        return CategoryCountResponseModelList.newInstance(<CategoryCountResponseModelList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CategoryCountResponseModelList) {
        if (!obj) return;

        models.CategoryCountResponseModelList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CategoryCountResponseModelList): boolean {
        Object.setPrototypeOf(obj, CategoryCountResponseModelList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Inventory category count details
     */
    count: string;

    /**
     * Name of the category
     */
    resource_category: string;

}
